import * as Yup from 'yup'
import type { TFunction } from 'i18next'

import type { Address } from '@dhl/input-address'

export const createBillingUnitValidationSchema = (t: TFunction) =>
  Yup.object({
    trackerCodeMin: Yup.number().required(t('admin.billingUnitsPage.error')),
    trackerCodeMax: Yup.number().required(t('admin.billingUnitsPage.error')),
  })
